import * as React from 'react'
import { useMemo } from 'react'
import { ExtendedInvoiceOverviewDto, InvoiceFilterType, InvoiceOverviewCount, InvoiceSortingType } from './InvoiceOverview'
import { BaseOverviewHeaderItemProps } from '../../BaseOverview/BaseOverview'
import useViewport, { Viewport } from '../../../hooks/useViewport'
import useCurrencies from '../../../hooks/useCurrencies'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import BaseOverviewCountBadge from '../../BaseOverview/BaseOverviewCountBadge'
import { InvoiceListItemTurnover } from './InvoiceListItem'

export default function InvoiceHeaderItem(
    props: BaseOverviewHeaderItemProps<ExtendedInvoiceOverviewDto, InvoiceFilterType, InvoiceSortingType, InvoiceOverviewCount>,
) {
    const { viewport, isViewport } = useViewport()
    const { getCurrency } = useCurrencies()

    const listItemSmall = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])
    const listItemMedium = useMemo<boolean>(() => isViewport('>=', Viewport.XXL), [viewport])

    if (listItemSmall) {
        return (
            <>
                <BaseOverviewCountBadge {...props} />
                <div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div>
                        {props.count.currencies?.map((currency, index) => (
                            <MoneyText key={index} amount={currency.total} currency={getCurrency(currency.currency)} align="right" />
                        ))}
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <BaseOverviewCountBadge {...props} />
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>{props.count.currencies?.map((currency, index) => <InvoiceListItemTurnover key={index} item={currency} />)}</div>
            {listItemMedium && <div></div>}
            {listItemMedium && (
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText
                            key={index}
                            value={{
                                currency: currency.outstandingPrice?.currency || currency.currency,
                                amount: currency.outstandingPrice?.total || '0.00',
                            }}
                            textProps={{
                                size: 300,
                            }}
                            align="right"
                        />
                    ))}
                </div>
            )}
            <div></div>
            <div></div>
        </>
    )
}
